@if (paymentSummary$ | async; as payment) {
<div class="app-payment-confirm">
  @switch (payment.operationType) { @case (paymentType.CURRENCY_EXCHANGE) {
  <app-image class="app-payment-confirm-icon" name="currency-exchange"></app-image>
  } @default {
  <app-image class="app-payment-confirm-icon" name="banktransfer"></app-image>
  } }
  <dl>
    @if (!isPaymentCurrencyExchange(payment)) { @if (payment?.beneficiaryName) {
    <dt translate>payment.beneficiaryName.label</dt>
    <dd>{{ payment.beneficiaryName }}</dd>
    }
    <dt translate>payment.beneficiaryAccountNumber.label</dt>
    <dd data-cy="payment-confirm-beneficiary-account">{{ payment.beneficiaryAccountNumber | iban }}</dd>
    @if (payment.institution) {
    <dd>{{ payment.institution.name }}</dd>
    } @if (!payment.institution) { @if (payment.beneficiaryBankIdentifier) {
    <dt translate>payment.beneficiaryBankIdentifier.label</dt>
    <dd>{{ payment.beneficiaryBankIdentifier }}</dd>
    } @if (payment.beneficiaryBankName) {
    <dt translate>payment.beneficiaryBankName.label</dt>
    <dd>{{ payment.beneficiaryBankName }}</dd>
    } @if (payment.beneficiaryBankAddress) {
    <dt translate>payment.beneficiaryBankAddress.label</dt>
    <dd>{{ payment.beneficiaryBankAddress }}</dd>
    } @if (payment.beneficiaryBankCountry) {
    <dt translate>payment.receiverInfo.beneficiaryBankCountry.label</dt>
    <dd>{{ payment.beneficiaryBankCountry | country}}</dd>
    } } @if (payment.instructionIdentification) {
    <dt translate>payment.receiverInfo.instructionIdentification.label</dt>
    <dd>{{ payment.instructionIdentification | instructionCode }}</dd>
    } @if (showIbanInPaymentAccountSelection && payment.payerAccount) {
    <dt translate>payment.payerAccount.label</dt>
    <dd>
      <span>{{ payment.payerAccount.accountName}}</span><br />
      <span>{{ payment.payerAccount.iban | iban}}</span>
    </dd>
    } @if (payment.feeAccount) {
    <dt translate>payment.feeAccount.label</dt>
    <dd>
      <span>{{ payment.feeAccount.accountName}}</span><br />
      <span>{{ payment.feeAccount.iban | iban}}</span>
    </dd>
    } @if (displayExchangeAmount(payment)) {
    <dt translate>payment.amount.label</dt>
    <dd data-cy="payment-confirm-amount">{{ payment.amount | currencySymbol: payment.currency | currencyRight }}</dd>
    <dt translate>payment.exchangeAmount.label</dt>
    <dd data-cy="payment-confirm-amount">{{ payment.initialAmount | currencySymbol: payment.initialCurrency | currencyRight }}</dd>
    @if (payment.fee) {
    <dd>
      {{ feeTranslationKey | translate: locale.language : { total: feeTranslationParams.total ? (feeTranslationParams.total | currencySymbol:
      payment.total.currency | currencyRight) : null, amount: feeTranslationParams.amount ? (feeTranslationParams.amount | currencySymbol: primaryCurrency |
      currencyRight) : null, fee: feeTranslationParams.fee | currencySymbol: payment.fee.currency | currencyRight } }}
    </dd>
    } } @else {
    <dt translate>payment.amount.label</dt>
    <dd data-cy="payment-confirm-amount">{{ primaryAmount | currencySymbol: primaryCurrency | currencyRight }}</dd>
    @if (payment.fee) {
    <dd>
      {{ feeTranslationKey | translate: locale.language : { total: feeTranslationParams.total ? (feeTranslationParams.total | currencySymbol:
      payment.total.currency | currencyRight) : null, amount: feeTranslationParams.amount ? (feeTranslationParams.amount | currencySymbol: primaryCurrency |
      currencyRight) : null, fee: feeTranslationParams.fee | currencySymbol: payment.fee.currency | currencyRight } }}
    </dd>
    } } @if (payment.serviceChargeDetails) {
    <dt translate>payment.serviceChargeDetails.label</dt>
    <dd translate>{{ payment.serviceChargeDetails | serviceChargeDetails }}</dd>
    } @if (payment.waitForFunds) {
    <dt translate>payment.waitForFunds.label</dt>
    <dd>{{ payment.waitForFunds | yesNo}}</dd>
    } } @else { @if (showIbanInPaymentAccountSelection) {
    <dt translate>payment.payerAccount.label</dt>
    <dd>
      <span>{{ payment.payerAccount.accountName}}</span><br />
      <span>{{ payment.payerAccount.iban | iban}}</span>
    </dd>
    }
    <dt translate>payment.amount.label</dt>
    <dd>{{ payment.initialAmount | currencySymbol: payment.initialCurrency | currencyRight }}</dd>
    @if (payment.tieredFeesApplied) {
    <dd>
      {{ 'payment.amount.extraWithTilde' | translate:locale.language: { total: payment.total.amount | currencySymbol: payment.total.currency | currencyRight,
      fee: payment.fee.amount | currencySymbol: payment.fee.currency | currencyRight } }}
    </dd>
    } @else {
    <dd>
      {{ 'payment.amount.extra' | translate:locale.language: { total: payment.total.amount | currencySymbol: payment.total.currency | currencyRight, fee:
      payment.fee.amount | currencySymbol: payment.fee.currency | currencyRight } }}
    </dd>
    }
    <dt translate>payment.amountYouGet.label</dt>
    <dd>{{ payment.amount | currencySymbol: payment.currency | currencyRight }}</dd>
    } @if (payment.exchangeRate) {
    <dt translate>payment.exchangeRate.label</dt>
    <dd
      [innerHTML]="'payment.exchangeRate.template' | translate:locale.language : { exchangeRate: payment.exchangeRate, initialCurrency:
        (payment.exchangeRateCurrencyPair.baseCurrency | currencyCodeSymbol), currency: (payment.exchangeRateCurrencyPair.quoteCurrency | currencyCodeSymbol) }"
    ></dd>
    } @if (!!payment.paymentDetails || !!payment.paymentCode) { @if (payment.paymentDetails) {
    <dt translate>payment.paymentDetails.label</dt>
    <dd>{{ payment.paymentDetails }}</dd>
    } @else {
    <dt translate>payment.paymentCode.label</dt>
    <dd>{{ payment.paymentCode }}</dd>
    } } @if (payment.attachments?.length) {
    <dt translate>payment.attachments</dt>
    <dd>
      <app-file-upload [files]="payment.attachments" [readonly]="true"></app-file-upload>
    </dd>
    } @if (payment.scheduled) {
    <dt translate>payment.scheduled.details.frequency</dt>
    <dd>{{ 'payment.scheduled.period.'+ payment.periodType | translate:locale.language }}</dd>
    <dt translate>payment.scheduled.details.startDate</dt>
    <dd>{{ payment.fromDate | appDate: locale.language }}</dd>
    @if (payment.tillDate) {
    <dt translate>payment.scheduled.details.endDate</dt>
    <dd>{{ payment.tillDate | appDate: locale.language }}</dd>
    } } @if (payment.requestedExecutionDate) {
    <dt translate>payment.details.executionDate</dt>
    <dd>{{ payment.requestedExecutionDate }}</dd>
    }
    <app-payment-additional-info
      [payment]="payment"
      [suggestedBeneficiaryAddress]="paymentService.suggestedBeneficiaryAddress"
      [paymentStatus]="paymentStatus"
      [paymentOperationType]="payment.operationType"
    ></app-payment-additional-info>
  </dl>
  @if (isPayementStatusCreated()) {
  <app-alert></app-alert>
  <app-tfa
    [id]="payment.operationId"
    [usage]="tfaUsage"
    [token]="payment"
    [hasBg]="true"
    [hasTitle]="true"
    [deleteOnCancel]="true"
    (canceled)="canceled()"
    (confirmed)="confirmed()"
    (backToInitialStep)="paymentService.backToInitialStep()"
  ></app-tfa>
  } @else {
  <h3 translate>payment.beneficiaryAddressSuggestion</h3>
  <button
    nz-button
    nzType="primary"
    nzSize="large"
    data-cy="payment-confirm-suggestion-accept-button"
    [nzLoading]="submitButtonLoading$ | async"
    [disabled]="(submitButtonDisabled$ | async) "
    (click)="acceptSuggestedAddress()"
    translate
  >
    common.yes
  </button>
  <button
    nz-button
    nzType="link"
    type="button"
    data-cy="payment-confirm-suggestion-reject-button"
    [nzLoading]="submitButtonLoading$ | async"
    [disabled]="(submitButtonDisabled$ | async) "
    (click)="rejectSuggestedAddress()"
    translate
  >
    common.no
  </button>
  }
</div>
}
